import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { ButtonContainer } from "./Action.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import AddEditSpecificCondition from "../../../AddEditSpecificCondition";
import "../../SpecificConditionList.scss";

const Action = (props) => {
  const { t, data, onRefreshData, updateRefeshStatus } = props;

  const [
    isAddSpecificConditionPopupVisible,
    setAddSpecificConditionPopupVisible,
  ] = useState(false);
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const handleDisable = () => {
    setConfirmVisibility(true);
  };

  const editSpecificCondition = () => {
    setAddSpecificConditionPopupVisible(true);
  };

  const closeSpecificConditionCreationPopup = () => {
    setAddSpecificConditionPopupVisible(false);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };
  useEffect(() => {
    if (isConfirm) {
      const formStatus = data.isActive ? "0" : 1;
      if (data.isActive === 1) {
        axios
          .delete(`/general/specificConditions/${data.id}`)
          .then(() => {
            onRefreshData(true);
          })
          .catch((error) => {
            onRefreshData(true);
            handleApiError(error);
          });
      } else {
        axios
          .put(`/general/specificConditions/${data.id}`, {
            ...data,
            country: JSON.stringify(data.country),
            isActive: formStatus,
          })
          .then(() => {
            onRefreshData(true);
          })
          .catch((error) => {
            onRefreshData(true);
            handleApiError(error);
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  return (
    <ButtonContainer>
      <div>
        <Image
          src={editIcon}
          onClick={editSpecificCondition}
          title={t("GENERIC_ACTION_TOOLTIP_EDIT")}
          alt={t("GENERIC_ACTION_TOOLTIP_EDIT")}
          className="specificCondition-list__image-action-icon"
        />
        {data.isActive == 1 && (
          <Image
            src={deleteIcon}
            onClick={handleDisable}
            alt={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
            title={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
            className="specificCondition-list__image-action-icon"
          />
        )}
        {data.isActive == 0 && (
          <Image
            src={activateIcon}
            onClick={handleDisable}
            alt={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
            title={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
            className="specificCondition-list__image-action-icon"
          />
        )}
      </div>

      {isAddSpecificConditionPopupVisible && (
        <AddEditSpecificCondition
          title={t("SPECIFIC_CONDITION_NEW")}
          onClose={closeSpecificConditionCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
          selectedSpecificCondition={data}
          isEditMode
          id={data.id}
        />
      )}
      {isConfirmVisible && (
        <WarningPopUp
          title={
            data.isActive == 0
              ? t("SPECIFIC_CONDITIONS_CONFIRMATION_BOX_ENABLE")
              : t("SPECIFIC_CONDITIONS_CONFIRMATION_BOX_DELETE")
          }
          message={
            data.isActive == 0
              ? t("SPECIFIC_CONDITIONS_CONFIRMATION_BOX_ENABLE_CONTENT")
              : t("SPECIFIC_CONDITIONS_CONFIRMATION_BOX_DELETE_CONTENT")
          }
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ButtonContainer>
  );
};

Action.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(Action);
